import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./Contexts/LanguageContext";

// Importing pages
import Index from "./Pages/Index";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Portfolio from "./Pages/Portfolio";
import News from "./Pages/News";
import Testimonials from "./Pages/Testimonials";

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Index Page Route */}
          <Route path="/" element={<Index />} />

          {/* About Route */}
          <Route path="/about" element={<About />} />

          {/* News Route */}
          <Route path="/news" element={<News />} />

          {/* Testimonials Route */}
          <Route path="/testimonials" element={<Testimonials />} />

          {/* Contact Route */}
          <Route path="/contact" element={<Contact />} />

          {/* Portfolio Route */}
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

export default App;